import { GetGlobalSearchResultsUseCase } from './GetGlobalSearchResultsUseCase'
import { globalSearchRepository } from '../../../data-access/repositories'

export const getGlobalSearchResults = new GetGlobalSearchResultsUseCase({
  globalSearchRepository,
}).execute
